import { render, staticRenderFns } from "./switchShippingWarehouseModal.vue?vue&type=template&id=0125aaa7"
import script from "./switchShippingWarehouseModal.vue?vue&type=script&lang=js"
export * from "./switchShippingWarehouseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports